import { TModifier } from 'shared/common/packages/Filters';
import { getExtendedRegion } from 'shared/common/packages/Filters/shared/containers/filters/GeoContainer/helpers';
import { getGeoValue, getTermsValue } from 'shared/common/packages/JsonQuery';

interface IParameters {
  prevJsonQuery: TJsonQuery;
  nextJsonQuery: TJsonQuery;
}

export const getAppliedModifiers = ({ prevJsonQuery, nextJsonQuery }: IParameters) => {
  const modifiers: TModifier[] = [];

  const prevRegionId = getTermsValue('region')(prevJsonQuery);
  const nextRegionId = getTermsValue('region')(nextJsonQuery);

  const geoValue = getGeoValue()(nextJsonQuery);

  if (prevRegionId && nextRegionId && nextRegionId[0] !== prevRegionId[0]) {
    modifiers.push({ action: 'setRegion', arguments: [getExtendedRegion(nextRegionId[0])] });
  }

  if (geoValue?.length) {
    modifiers.push({ action: 'selectGeo', arguments: [geoValue[0]] });
  }

  return modifiers;
};
